export { default as SortableTable } from './SortableTable'
export { default as sortableReducerFactory } from './redux/reducers'
